module.exports = __webpack_public_path__ + "static/media/1.5a1f5e69.svg";